import type { VanishingBottomToastProps } from './VanishingBottomToast';

import { createContext, type Dispatch, type SetStateAction, useContext } from 'react';

type SetVanishingBottomToastProps = Dispatch<SetStateAction<VanishingBottomToastProps | null>>;

export const SetVanishingBottomToastPropsContext = createContext<SetVanishingBottomToastProps>(
    () => {},
);

export const useSetVanishingBottomToastPropsContext = () =>
    useContext(SetVanishingBottomToastPropsContext);
